// Outfits e montarias da loja (os mesmos da loja do Global), com prévia e preço em Noxara Coins.
// CSS em client/css-parts/store.css (prefixo .st-).
import { useState } from 'preact/hooks';
import { STORE_MOUNTS, STORE_OUTFITS } from '../../../../shared/src/game/store-cosmetics';
import { MOUNT_LIST } from '../../../../shared/src/game/outfit-list';
import { outfitByLook, type Cosmetics } from '../../../../shared/src/game/outfits';
import type { Outfit } from '../../../../shared/src/protocol';
import { Portrait } from './BattleList';

const PRICES: Array<[number, string]> = [[0, 'Todos'], [100, '100'], [250, '250'], [500, '500']];

export function StoreCosmetics(props: { kind: 'outfits' | 'mounts'; cosmetics: Cosmetics; outfit: Outfit; sex: 'male' | 'female'; coins: number; onBuy: (offer: string) => void }) {
  const [q, setQ] = useState('');
  const [price, setPrice] = useState(0);
  const f = (n: string, p: number) => (!q || n.toLowerCase().includes(q.toLowerCase())) && (!price || p === price);
  const outfitHas = (male: number) => { const def = outfitByLook(male); const got = def ? props.cosmetics.outfits?.[def.name] : undefined; return got !== undefined && (got & 3) === 3; };
  const mountHas = (id: number) => (props.cosmetics.mounts ?? []).includes(id);
  const owned = props.kind === 'outfits' ? STORE_OUTFITS.filter((o) => outfitHas(o.male)).length : STORE_MOUNTS.filter((m) => mountHas(m.id)).length;
  const total = props.kind === 'outfits' ? STORE_OUTFITS.length : STORE_MOUNTS.length;
  const tile = (key: string | number, portrait: preact.ComponentChildren, name: string, p: number, has: boolean, offer: string) => (
    <div key={key} class={'st-cos' + (has ? ' own' : props.coins < p ? ' short' : '')}>
      <div class="st-cos-ped">{portrait}</div>
      <small class="st-cos-name" title={name}>{name}</small>
      {has ? <span class="st-cos-own">✔ Já é seu</span>
        : <button class="tb-button green st-price" disabled={props.coins < p} onClick={() => props.onBuy(offer)} title={props.coins < p ? `Faltam ${(p - props.coins).toLocaleString('pt-BR')} coins` : ''}><i class="st-coin" />{p}</button>}
    </div>
  );
  const list = props.kind === 'outfits'
    ? STORE_OUTFITS.filter((o) => f(o.name, o.price)).map((o) => tile(o.male,
      <Portrait outfit={{ ...props.outfit, lookType: props.sex === 'female' ? o.female : o.male, addons: 3, mount: undefined }} size={48} />, o.name, o.price, outfitHas(o.male), 'of:' + o.male))
    : STORE_MOUNTS.filter((m) => f(m.name, m.price)).map((m) => tile(m.id,
      <Portrait outfit={{ lookType: MOUNT_LIST.find((x) => x.id === m.id)?.look ?? 0, head: 0, body: 0, legs: 0, feet: 0, addons: 0 }} size={48} />, m.name, m.price, mountHas(m.id), 'mt:' + m.id));
  return (
    <div class="st-cosw">
      <div class="st-cos-bar">
        <input class="st-search" placeholder="Procurar..." value={q} onInput={(e) => setQ((e.target as HTMLInputElement).value)} />
        <div class="st-chips">{PRICES.map(([v, l]) => <button key={v} class={'st-chip' + (price === v ? ' on' : '')} onClick={() => setPrice(v)}>{v ? <><i class="st-coin" />{l}</> : l}</button>)}</div>
        <span class="st-owned" title="Quantos desta aba você já tem">{owned}/{total} na coleção</span>
      </div>
      <p class="st-note">{props.kind === 'outfits' ? '👕 Os outfits vêm completos, com os dois addons. As cores você escolhe na janela de Outfits.' : '🐎 Toda montaria dá +10 de velocidade, como no Tibia.'}</p>
      <div class="st-cos-grid">
        {list}
        {list.length === 0 && <p class="st-empty">Nada encontrado com esse filtro.</p>}
      </div>
    </div>
  );
}
